export const GCM_BANNER_IMAGE = 'GCM_BANNER_IMAGE'
export const GCM_REGION_STATS = 'GCM_REGION_STATS'
export const GCM_INDIAN_CITIES = 'GCM_INDIAN_CITIES'
export const COSTING_INFO = 'COSTING_INFO'
export const DROP_DOWN_COLLAPSE = 'DROP_DOWN_COLLAPSE'
export const SET_ENABLE_GET_COST = 'SET_ENABLE_GET_COST'
export const SET_STAY_DURATION = 'SET_STAY_DURATION'
export const SET_LOADING = 'SET_LOADING'
export const ARRIVAL_AIRPORT_CHANGE = 'ARRIVAL_AIRPORT_CHANGE'
export const NATIONALITY_GLOBAL = 'NATIONALITY_GLOBAL'
export const DEPARTURE_AIRPORT_CHANGE = 'DEPARTURE_AIRPORT_CHANGE'
export const DEPARTURE_DATE_CHANGED = 'DEPARTURE_DATE_CHANGED'
export const INTL_FLIGHTS_BOOKED = 'INTL_FLIGHTS_BOOKED'
export const ARRIVING_DIFFERENT = 'ARRIVING_DIFFERENT'
export const TRAVEL_TYPE = 'TRAVEL_TYPE'
export const UPDATE_COSTING = 'UPDATE_COSTING'
export const ADD_ROOM = 'ADD_ROOM'
export const REMOVE_ROOM = 'REMOVE_ROOM'
export const SELECT_ROOM = 'SELECT_ROOM'
export const ADULTS_INCREASE = 'ADULTS_INCREASE'
export const ADULTS_DECREASE = 'ADULTS_DECREASE'
export const CHILD_INCREASE = 'CHILD_INCREASE'
export const CHILD_DECREASE = 'CHILD_DECREASE'
export const CHILD_AGE_SELECT = 'CHILD_AGE_SELECT'
export const ADULT_AGE_SELECT = 'ADULT_AGE_SELECT'
export const CANCEL = 'CANCEL'
export const DONE = 'DONE'
export const CRED_GCM_MAL_IMAGE = 'CRED_GCM_MAL_IMAGE'
export const CUSTOM_CONFIG_TRAVELLER_TYPE = ['FAMILY', 'FRIENDS']
export const USER_INTENT = 'USER_INTENT'
export const GCM_PASSENGER_INFO = 'GCM_PASSENGER_INFO'
export const GCM_RESET_PASSENGER_INFO = 'GCM_RESET_PASSENGER_INFO'
export const GCM_RESET_DEFAULT_LOGIN = 'GCM_RESET_DEFAULT_LOGIN'

export const GCM_SIGNUP_FAILS = 'GCM_SIGNUP_FAILS'
export const GCM_SIGNUP_FAILS_RESET = 'GCM_SIGNUP_FAILS_RESET'
export const SIGNUP_FORM_GCM = 'SIGNUP_FORM_GCM'
export const PAID_LANDING_GCM = 'PAID_LANDING_GCM'
export const LOGIN_FORM_GCM = 'LOGIN_FORM_GCM'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const GCM_OTP = 'GCM_OTP'
export const SET_FORGOT_PASSWORD = 'SET_FORGOT_PASSWORD'

export const CRUISE_CABIN_CONFIG_GCM = 'CRUISE_CABIN_CONFIG_GCM'
export const JOURNEY = 'JOURNEY'
export const GCM = 'GCM'
export const OTP = 'OTP'
export const CHOOSE_LANGUAGE = 'CHOOSE_LANGUAGE'
export const UPDATE_USER = 'UPDATE_USER'
export const SHOW_SUBMIT_SUCCESS = 'SHOW_SUBMIT_SUCCESS'
export const SHOW_OTP = 'SHOW_OTP'
